
import React, { useState, useEffect, useRef } from 'react';
import {
  LogoImage,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownButton,
  LanguageDropdownMenu,
  DropdownLanguageItem,
  LogOutDiv,
  MenuFlexBox,
  MobileDropdown,
  MobileDropdownButton,
  MobileDropdownMenu,
  MobileDropdownItem,
  MobileLanguageDropdownMenu
} from './Navbar.styles';
// import Logo from '../../assets/logos/gr-logo.jpg';
import logoEn from '../../assets/logos/en-logo.png';
import logoGr from '../../assets/logos/gr-logo.jpg';
import {ReactComponent as HamburgerMenu} from '../../assets/svgs/burger-menu.svg';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as DownArrow } from '../../assets/svgs/down-arrow-dark.svg';
import { ReactComponent as RightArrow } from '../../assets/svgs/right-arrow-option.svg';
import { ReactComponent as LanguagesSVG } from '../../assets/svgs/languages.svg';
import { ReactComponent as ProfileSVG } from '../../assets/svgs/profile-icon.svg';
import { ReactComponent as LogOutSVG } from '../../assets/svgs/logout.svg';
import { jwtDecode } from 'jwt-decode';
import styled from '@emotion/styled';
import { useLocation } from 'react-router-dom';

const Container = styled.div`
  display:flex;
  padding: 10px 15px;
  justify-content: space-between;
`;

const HamburgerButton = styled.button`
  font-size: 1.8rem;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 2100;
  color: #385963;
  display: ${({ open }) => (open ? 'none' : 'block')}; /* hide when menu is open */
`;

// ⬇️ Update your MobileMenuOverlay
const MobileMenuOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0; /* attach to right instead of full screen */
  width: 85%; /* adjust to 80% or 90% as you like */
  height: 100%;
  background-color: #fff;
  z-index: 999999;
  display: flex;
  flex-direction: column;
  padding: 20px;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease-in-out;
  box-shadow: -4px 0 10px rgba(0,0,0,0.2);
  align-items: center;
  overflow-y: auto;
  text-align: center;
`;


// const MobileMenuOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0; /* full-screen overlay */
//   width: 100%;
//   height: 100%;
//   background-color: #fff;
//   z-index: 999999;
//   display: flex;
//   flex-direction: column;
//   padding: 20px;
//   transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
//   transition: transform 0.3s ease-in-out;
//   box-shadow: -4px 0 10px rgba(0,0,0,0.2);
//   align-items: center;
//   overflow-y: auto; /* allow scrolling if content exceeds viewport */
//     text-align: center;
//     align-items: center;

// `;

const CloseButton = styled.button`
  align-self: flex-start;
   font-size: 14px;
  background: none;
  border: none;
  cursor: pointer;
  color: #385963;
  margin-bottom: 5px;
`;

const MobileNavTabs = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0;

//   & > li {
//     width: 100%;
//     text-align: center;
//   }

  a, li {
    color: #385963;
    text-decoration: none;
    font-size: 14px;
    // padding: 12px 0;
    display: block;
    width: 100%;
    text-align: center;

    &:hover {
      color: #91abb3;
      transition: 0.3s;
    }
  }
`;

const NavbarSmall = ({ setAccessibilityOpen }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL || '/';
  const [open, setOpen] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [signedIn, setSignedIn] = useState(Boolean(sessionStorage.getItem('loggedIn')));
  const [userName, setUserName] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [providerProfileOpen, setProviderProfileOpen] = useState(false);
  const [visitorProfileOpen, setVisitorProfileOpen] = useState(false);
  const [isDestinationsOpen, setDestinationsOpen] = useState(false);
  const [isExperiencesOpen, setExperiencesOpen] = useState(false);
  const [isAmenitiesOpen, setAmenitiesOpen] = useState(false);
  const location = useLocation();
  const [destinationCategories, setDestinationCategories] = useState([]);
  const [experienceCategories, setExperienceCategories] = useState([]);
  const [amenityCategories, setAmenityCategories] = useState([]);

  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const languages = [
    { code: 'en', label: 'EN' },
    { code: 'gr', label: 'GR' },
  ];
  const currentLanguage = languages.find((lang) => lang.code === i18n.language);
 const [activeLink, setActiveLink] = useState('/'); 
  // refs
  const dropdownRef = useRef(null);
  const providerProfileRef = useRef(null);
  const visitorProfileRef = useRef(null);
  const destinationsButtonRef = useRef(null);
  const amenitiesButtonRef = useRef(null);
  const experiencesButtonRef = useRef(null);
  const destinationsMenuRef = useRef(null);
  const amenitiesMenuRef = useRef(null);
  const experiencesMenuRef = useRef(null);
    const providerProfileButtonRef = useRef(null); 
    const visitorProfileButtonRef = useRef(null); 

  useEffect(() => {
    const tokenString = sessionStorage.getItem('token');
    if (tokenString) {
      try {
        const decodedToken = jwtDecode(decodeURIComponent(tokenString));
        const role = decodedToken.prn || decodedToken.role || '';
        setUserRole(role);
        setUserName(decodedToken.sub || '');
      } catch (err) {
        console.error('Error decoding token', err);
      }
    }

    const fetchCategories = async (endpoint, setter) => {
      try {
        const res = await fetch(`${BASE_URL}${endpoint}`);
        if (!res.ok) throw new Error(res.status);
        const data = await res.json();
        setter(data);
      } catch (err) {
        console.error(`Error fetching ${endpoint}:`, err);
      }
    };

    fetchCategories('DestinationCategory', setDestinationCategories);
    fetchCategories('ExperienceCategory', setExperienceCategories);
    fetchCategories('AmenityCategory', setAmenityCategories);
  }, [signedIn, BASE_URL]);

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('loggedIn');
    sessionStorage.removeItem('userRole');
    navigate('/');
    window.location.reload();
  };

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    sessionStorage.setItem('selectedLanguage', langCode);
    setDropdownOpen(false);
  };

   const handleProviderProfileNavigation = (component) => {
      // Navigate to the /destinations page with active tab information
      if(component==='' && userRole==="PreApprovedProvider"){
           navigate('/profile-menu-pre-approved-provider');
      }else{
      navigate('/profile-menu-provider', { state: { activeComponent: component } });
      setProviderProfileOpen(false);
      }
    };

    const handleVisitorProfileNavigation = (component) => {
      // Navigate to the /destinations page with active tab information
      navigate('/profile-menu-visitor', { state: { activeComponent: component } });
      setVisitorProfileOpen(false);
    };


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        destinationsButtonRef.current && destinationsMenuRef.current &&
        !destinationsButtonRef.current.contains(e.target) &&
        !destinationsMenuRef.current.contains(e.target)
      ) setDestinationsOpen(false);

      if (
        amenitiesButtonRef.current && amenitiesMenuRef.current &&
        !amenitiesButtonRef.current.contains(e.target) &&
        !amenitiesMenuRef.current.contains(e.target)
      ) setAmenitiesOpen(false);

      if (
        experiencesButtonRef.current && experiencesMenuRef.current &&
        !experiencesButtonRef.current.contains(e.target) &&
        !experiencesMenuRef.current.contains(e.target)
      ) setExperiencesOpen(false);

      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setDropdownOpen(false);
      if (providerProfileRef.current && !providerProfileRef.current.contains(e.target)) setProviderProfileOpen(false);
      if (visitorProfileRef.current && !visitorProfileRef.current.contains(e.target)) setVisitorProfileOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


const renderCategoryDropdown = (title, isOpen, setDropdownOpenState, items, routeKey, buttonRef, menuRef, closeMobileMenu) => {
  // Map routeKey → activeComponent to match NavbarLarge
  const activeComponentMap = {
    destinations: 'mainDestinations',
    amenities: 'mainAmenities',
    experiences: 'mainExperiences',
  };

  return (
    // <li style={{ placeItems: "center"}}>
    <li style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <MobileDropdown >
        <DropdownButton
          style={{ placeSelf: "center", margin: "0px 0px" }}
          ref={buttonRef}
          onClick={() => setDropdownOpenState(!isOpen)}
        >
         <div style={{fontSize:'14px'}}>{i18n.t(title)}</div> 
          <DownArrow
            style={{
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: '0.3s',
            }}
          />
        </DropdownButton>
        {isOpen && (
          <MobileDropdownMenu ref={menuRef} style={{ zIndex: 3000, width: '100%'}}>
            {items.map((cat) => (
              <MobileDropdownItem
                style={{ color: "#f0f4f5",textAlign:"left" }}
                key={cat.id}
                onClick={() => {
                  navigate(`/${routeKey}`, {
                    state: {
                      activeComponent: activeComponentMap[routeKey], 
                      categoryId: cat.id,
                    },
                  });
                  setDropdownOpenState(false);
                  closeMobileMenu(false);
                }}
              >
                <RightArrow height={10} width={30} /> {cat.name[selectedLanguage]}
              </MobileDropdownItem>
            ))}
          </MobileDropdownMenu>
        )}
      </MobileDropdown>
    </li>
  );
};


  const Logo = i18n.language === 'en' ? logoEn : logoGr;
  return (
    <Container>
    {!open && (
       <Link to="/">
        <LogoImage src={Logo} alt="Logo"/>
      </Link>
     )}

      <HamburgerButton onClick={() => setOpen(true)} open={open}>
          <HamburgerMenu   height={30} width={30} style={{ marginBottom: 10 }}/> 
      </HamburgerButton>
      <MobileMenuOverlay open={open}>
        <CloseButton style={{fontSize:'30px'}} onClick={() => setOpen(false)}>×</CloseButton>

         <Link to="/" onClick={() => setOpen(false)}>
           <LogoImage src={Logo} alt="Logo" style={{ marginBottom: '50px', width: '100px', height: '100px' }} />
         </Link>


        <MenuFlexBox style={{ flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          <MobileNavTabs>

             <li>
              <a 
              // href="https://www.olympus-riviera.gr/embed/map"
              //  target="_blank" 
              //  rel="noopener noreferrer"
                href="#!"
                onClick={() => {
                  setAccessibilityOpen(true);
                  setOpen(false);
                }}
               >
                {i18n.t('accessibilityPoints')}
              </a>
            </li>

            <li>
              <Link to="/about-pieria" onClick={() => setOpen(false)}>{i18n.t('aboutPieria')}</Link>
            </li>

            {renderCategoryDropdown('destinations', isDestinationsOpen, setDestinationsOpen, destinationCategories, 'destinations', destinationsButtonRef, destinationsMenuRef, setOpen)}
            {renderCategoryDropdown('amenities', isAmenitiesOpen, setAmenitiesOpen, amenityCategories, 'amenities', amenitiesButtonRef, amenitiesMenuRef, setOpen)}
            {renderCategoryDropdown('experiences', isExperiencesOpen, setExperiencesOpen, experienceCategories, 'experiences', experiencesButtonRef, experiencesMenuRef, setOpen)}


            <li>
              <Link to="/plan-your-trip" onClick={() => setOpen(false)}> {i18n.t('planYourTrip')}</Link>
            </li>
            <li>
              <Link to="/event-calendar" onClick={() => setOpen(false)}>    {i18n.t('calendar')}</Link>
            </li>

              { !signedIn &&
                              <li>
                                <Link to="/register-signIn" 
                                onClick={() => setOpen(false)}
                                 style={{ color: location.pathname === '/register-signIn' ? '#91abb3' : '#385963' }}
                                >
                                    {i18n.t('registerSignIn')}
                                </Link>
                            </li>}
                            { signedIn && userRole==="Provider" &&
                              <li >
                                 <MobileDropdown  style={{ placeSelf: "center", margin:"0px 0px" }}>
                                    <Link ref={providerProfileButtonRef} onClick={() => setProviderProfileOpen(!providerProfileOpen)} >
                                        {/* {userName} */}
                                        <ProfileSVG height={18} width={20} />
                                    </Link>
                                    
                                    {providerProfileOpen && (
                                        <MobileDropdownMenu ref={providerProfileButtonRef} >
                                            <MobileDropdownItem  style={{color:"#f0f4f5"}} onClick={() => { setDropdownOpen(false);  handleProviderProfileNavigation('crudProfile'); setOpen(false); }}>
                                                 <RightArrow height={10} width={30} /> 
                                                 {i18n.t('manageProfile')}
                                            </MobileDropdownItem>
                                            <MobileDropdownItem  style={{color:"#f0f4f5"}} onClick={() => { setDropdownOpen(false); handleProviderProfileNavigation('businesses'); setOpen(false);}}>
                                                  <RightArrow height={10} width={30} /> 
                                                  {i18n.t('amenities')}
                                            </MobileDropdownItem>
                                            <MobileDropdownItem  style={{color:"#f0f4f5"}} onClick={() => { setDropdownOpen(false); handleProviderProfileNavigation('crudProviderEventRequest'); setOpen(false);}}>
                                            <RightArrow height={10} width={30} /> 
                                               {i18n.t('events')}
                                            </MobileDropdownItem>
                                            <MobileDropdownItem  style={{color:"#f0f4f5"}} onClick={() => { setDropdownOpen(false); handleLogout(); setOpen(false);}}>
                                              <LogOutDiv>
                                                <LogOutSVG height={27} width={27} /> 
                                                <p>{i18n.t('signOut')}</p> 
                                              </LogOutDiv>
                                            </MobileDropdownItem>
                                            
                                        </MobileDropdownMenu>
                                    )}
                                </MobileDropdown>
                            </li>}

                              { signedIn && userRole==="PreApprovedProvider" &&
                              <li >
                                 {/* <MobileDropdown  style={{ placeSelf: "center", margin:"0px 0px" }}>
                                    <Link 
                                      ref={providerProfileButtonRef} 
                                      onClick={() => setProviderProfileOpen(!providerProfileOpen)}
                                     >
                                      
                                        <ProfileSVG height={18} width={20} />
                                    </Link> */}
                                     <MobileDropdown  style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        padding: '0',      
                                        margin: '0 auto',  
                                        height: '100%',
                                        width: '100%',     
                                      }}>
                                   <DropdownButton 
                                      ref={providerProfileButtonRef} 
                                      onClick={() => setProviderProfileOpen(!providerProfileOpen)}
                                     
                                    >
                                       {/* {userName} */}
                                       <ProfileSVG height={18} width={20} />
                                   </DropdownButton>
                                    
                                    {providerProfileOpen && (
                                        <MobileDropdownMenu ref={providerProfileButtonRef}>
                                            <MobileDropdownItem  style={{color:"#f0f4f5"}} onClick={() => { setDropdownOpen(false);  handleProviderProfileNavigation(''); setOpen(false);}}>
                                                 <RightArrow height={10} width={30} /> 
                                                 {i18n.t('manageProfile')}
                                            </MobileDropdownItem>
                                            <MobileDropdownItem  style={{color:"#f0f4f5"}} onClick={() => { setDropdownOpen(false); handleLogout(); setOpen(false);}}>
                                              <LogOutDiv >
                                                <LogOutSVG height={27} width={27} /> 
                                                <p>{i18n.t('signOut')}</p> 
                                              </LogOutDiv>
                                            </MobileDropdownItem>
                                            
                                        </MobileDropdownMenu>
                                    )}
                                </MobileDropdown>
                            </li>}
                            { signedIn && userRole==="RegisteredUser" &&
                                <li >
                                <MobileDropdown  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: '0',      
                                    margin: '0 auto',  
                                    height: '100%',
                                    width: '100%',     
                                  }}>
                                   <DropdownButton 
                                   ref={visitorProfileButtonRef} 
                                   onClick={() => setVisitorProfileOpen(!visitorProfileOpen)}
                                 
                                    >
                                       {/* {userName} */}
                                       <ProfileSVG height={18} width={20} />
                                   </DropdownButton>
                                   {visitorProfileOpen && (
                                       <MobileDropdownMenu ref={visitorProfileButtonRef} >
                                           <MobileDropdownItem  style={{color:"#f0f4f5"}} onClick={() => { setDropdownOpen(false);  handleVisitorProfileNavigation('crudProfileVisitor'); setOpen(false);}}>
                                                <RightArrow height={10} width={30} /> 
                                                {i18n.t('manageProfile')}
                                           </MobileDropdownItem>
                                           <MobileDropdownItem  style={{color:"#f0f4f5"}} onClick={() => { setDropdownOpen(false); handleVisitorProfileNavigation('preferences'); setOpen(false);}}>
                                                 <RightArrow height={10} width={30} /> 
                                                 {i18n.t('preferences')}
                                           </MobileDropdownItem>
                                           <MobileDropdownItem  style={{color:"#f0f4f5"}} onClick={() => { setDropdownOpen(false); handleVisitorProfileNavigation('pointsVisited'); setOpen(false);}}>
                                           <RightArrow height={10} width={30} /> 
                                           {i18n.t('pointsOfInterest')} 
                                           </MobileDropdownItem>
                                           <MobileDropdownItem  style={{color:"#f0f4f5"}} onClick={() => { setDropdownOpen(false); handleLogout(); setOpen(false);}}>
                                             <LogOutDiv>
                                               <LogOutSVG height={27} width={27}/> 
                                               <p>{i18n.t('signOut')}</p> 
                                             </LogOutDiv>
                                           </MobileDropdownItem>
                                           
                                       </MobileDropdownMenu>
                                   )}
                               </MobileDropdown>
                              </li>
                            }
            

            {/* Language */}
            {/* <li style={{placeItems:"center", padding:"0px"}}> */}
            <li style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <MobileDropdown >
                <DropdownButton style={{ placeSelf: "center", padding:"0px"}} ref={dropdownRef} onClick={() => setDropdownOpen(!dropdownOpen)} >
                  {currentLanguage ? currentLanguage.label : 'EN'}
                  <LanguagesSVG height={18} width={18} />
                </DropdownButton>
                {dropdownOpen && (
                  <LanguageDropdownMenu ref={dropdownRef} style={{ zIndex: 3000,transform: "translateX(-50%)" }}>
                    {languages.map((lang) => (
                      <DropdownLanguageItem  style={{color:"#f0f4f5"}} key={lang.code} onClick={() => {changeLanguage(lang.code); setDropdownOpen(!dropdownOpen)}}>{lang.label}</DropdownLanguageItem>
                    ))}
                  </LanguageDropdownMenu>
                )}
              </MobileDropdown>
            </li>

          </MobileNavTabs>
        </MenuFlexBox>
      </MobileMenuOverlay>
    </Container>
  );
};

export default NavbarSmall;
